var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrnementOffIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.416,
    height: 35,
    viewBox: "0 0 30.416 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#707070;}.b{fill:#9a9a9a;}.c{fill:#fff;}.d{fill:#4b5055;}.e{fill:#5a5f64;}.f{fill:#7d8287;}.g{fill:#919196;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-93.109 -41.351)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.058 63.966)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M229.938,291.3a.645.645,0,0,1-.646-.646v-10.81a.646.646,0,1,1,1.292,0v10.81A.646.646,0,0,1,229.938,291.3Z",
    transform: "translate(-229.292 -279.2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.856 41.351)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M142.922,47.166a5.822,5.822,0,0,1-.006,5.815,5.8,5.8,0,0,1-5.033,8.716,5.8,5.8,0,0,1-10.067,0,5.8,5.8,0,0,1-5.033-8.716,5.8,5.8,0,0,1,5.033-8.716,5.8,5.8,0,0,1,10.067,0A5.816,5.816,0,0,1,142.922,47.166Zm-4.491,5.815a3.206,3.206,0,0,0-2.791-4.833,3.207,3.207,0,0,0-5.583,0,3.206,3.206,0,0,0-2.791,4.833,3.206,3.206,0,0,0,2.791,4.833,3.207,3.207,0,0,0,5.583,0,3.207,3.207,0,0,0,2.791-4.833Z",
    transform: "translate(-122 -41.351)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.681 46.52)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M184.366,98.947a3.222,3.222,0,0,1-.014,3.231,3.206,3.206,0,0,1-2.791,4.833,3.207,3.207,0,0,1-5.583,0,3.206,3.206,0,0,1-2.791-4.833,3.206,3.206,0,0,1,2.791-4.833,3.207,3.207,0,0,1,5.583,0A3.217,3.217,0,0,1,184.366,98.947Zm-3.657,3.231a1.938,1.938,0,1,0-1.938,1.938A1.936,1.936,0,0,0,180.709,102.177Z",
    transform: "translate(-172.747 -95.716)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.766 51.043)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M217.646,143.286a1.938,1.938,0,1,1-1.938,1.938A1.936,1.936,0,0,1,217.646,143.286Z",
    transform: "translate(-215.708 -143.286)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.597 64.517)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241.892,285.1c.74.739-2.949,5.631-3.688,6.37a1.9,1.9,0,0,1-2.683-2.682c.739-.74,5.631-4.428,6.371-3.688Z",
    transform: "translate(-234.967 -285)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.85 66.419)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M189.791,308.26v.266a1.362,1.362,0,0,1-2.318.83c-.536-.531-2.882-3.745-2.351-4.276s3.744,1.816,4.276,2.346a1.363,1.363,0,0,1,.393.834Z",
    transform: "translate(-185.044 -305.001)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.109 70.222)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M102.15,349.441c-.075.921-.564,1.688-1.2,1.688H94.317c-.783,0-1.472-1.238-1.107-2.727l.006-.025A4.373,4.373,0,0,1,97.456,345h.352a4.365,4.365,0,0,1,4.26,3.442l.019.086A3.019,3.019,0,0,1,102.15,349.441Z",
    transform: "translate(-93.109 -345)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M135.568,349.441h-4.322c-.783,0-1.472-1.238-1.108-2.727l.006-.025a4.426,4.426,0,0,1,.809-1.689h.271a4.365,4.365,0,0,1,4.26,3.442l.019.086A3.019,3.019,0,0,1,135.568,349.441Z",
    transform: "translate(-126.527 -345)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.769 70.42)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M291.532,351.557a1.7,1.7,0,0,1-1.642,1.255h-9.344a1.717,1.717,0,0,1-1.6-2.307,5.167,5.167,0,0,1,4.022-3.357,5.087,5.087,0,0,1,.823-.067h2.856a5.157,5.157,0,0,1,4.8,3.312l.029.075A1.714,1.714,0,0,1,291.532,351.557Z",
    transform: "translate(-278.84 -347.081)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M316.38,351.557H308a1.714,1.714,0,0,1-1.706-1.717,1.734,1.734,0,0,1,.1-.591,5.193,5.193,0,0,1,1.411-2.1,5.087,5.087,0,0,1,.823-.067h2.856a5.157,5.157,0,0,1,4.8,3.312l.029.075A1.715,1.715,0,0,1,316.38,351.557Z",
    transform: "translate(-303.688 -347.081)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrnementOffIcon);
export default __webpack_public_path__ + "static/media/Ornement-OFF-icon.aae996067246e958fd1692be38952abe.svg";
export { ForwardRef as ReactComponent };